import { useMemo, useState, useCallback } from "react";

export const useBrandVideo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const brandConfiguration = useMemo(() => {
    try {
      const storedState = JSON.parse(localStorage.getItem("state") || "{}");
      return storedState?.brand?.configuration || {};
    } catch {
      return {};
    }
  }, []);

  const iframeUrl = brandConfiguration?.pmc_rereg_video_iframe;
  const fallbackVideoUrl = brandConfiguration?.pmc_rereg_fallback_video;

  const openVideo = useCallback(() => setIsOpen(true), []);
  const closeVideo = useCallback(() => setIsOpen(false), []);

  const hasVideo = Boolean(iframeUrl || fallbackVideoUrl);

  return {
    isOpen,
    openVideo,
    closeVideo,
    iframeUrl,
    fallbackVideoUrl,
    hasVideo,
  };
};